/**
 * BenchmarkCard (P168) -- Home tile for admin OR approver, linking to
 * the sector-benchmark surface. Exec-shaped (operators see nothing).
 */
import { useTranslation } from "react-i18next";

import { MarsadIcon } from "shared/components/MarsadIcon";
import { useMe } from "shared/api/useMe";
import { BrassLink } from "shared/components/BrassLink";
import { Card } from "shared/components/Card";

export function BenchmarkCard() {
  const { t } = useTranslation();
  const me = useMe();
  const canSee = me.data?.is_admin || me.data?.positions.includes("approver");
  if (!me.data || !canSee) {
    return null;
  }
  return (
    <Card testid="benchmark-card" className="space-y-2">
      <p className="flex items-center gap-1.5 font-mono text-[10.5px] uppercase tracking-[0.18em] text-ink-muted">
        <MarsadIcon name="benchmark" size={13} className="text-brand-brassDark" />
        {t("benchmark.card.heading")}
      </p>
      <p className="text-[12.5px] text-ink-2">{t("benchmark.card.body")}</p>
      <BrassLink to="/benchmark" testid="benchmark-card-open" className="inline-block">
        {t("benchmark.card.open")}
      </BrassLink>
    </Card>
  );
}
